module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInGrow",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "four-oh-four"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("404!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-1"
  }, [_vm._v("\n                Hmmm... Couldn't find that one!\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Try going to the\n                "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("home page")]), _vm._v("\n                or use the navigation links above to find what you're looking for.\n            ")], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46635e59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 156
// module chunks = 1